<template>
  <div class="conversation-header-details" :class="{ 'is-compact': compact }">
    <div class="conversation-header-details__subject">
      <MessageSquare v-if="compact" :size="18" class="tw-text-primary tw-flex-none" />
      <span class="conversation-header-details__title">{{ conversation.subject }}</span>
      <el-tag
        v-if="conversation.urgency === PatientConversationUrgencyEnum.Urgent"
        type="danger"
        size="small"
        round
        effect="light"
      >
        Urgent
      </el-tag>
    </div>
    <div v-if="conversation.member" class="conversation-header-details__patient">
      <span class="tw-font-medium">{{ conversation.member.full_name }}</span>
      <span class="tw-mx-1">•</span>{{ formatPatientDemographics(conversation.member) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { MessageSquare } from "lucide-vue-next"
import { PatientConversationDTO, PatientConversationUrgencyEnum } from "@vitable/asclepius-api-client-ts"
import { formatPatientDemographics } from "@/modules/patient-conversations/utils/patient-conversation-format"

defineProps<{
  conversation: PatientConversationDTO
  /** The floating panel's smaller header. */
  compact?: boolean
}>()
</script>

<style scoped lang="sass">
@import "@/styles/colors"

.conversation-header-details
  min-width: 0

  &__subject
    display: flex
    align-items: center
    gap: 8px
    min-width: 0

  &__title
    font-size: 18px
    font-weight: 700
    color: $primary
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap

  &__patient
    margin-top: 2px
    font-size: 13px
    color: $grey

  &.is-compact &__title
    font-size: 15px
    color: $empty-text

  &.is-compact &__patient
    font-size: 12px
</style>
